/**
 * Le visage de chaque type de point de correction — une seule table pour la carte du point et la
 * pastille posée sur la copie, pour qu'un « 3 » rouge sur la copie reste un « 3 » rouge sous elle.
 *
 * - `badge` : l'aplat de la pastille numérotée. Un aplat plein dont l'encre tient l'AA :
 *   `danger-deep` / `warning-deep` plutôt que le rouge et l'orange vifs, qui ne portent pas le
 *   blanc (`badgeFace`).
 * - `chip` + `icon` : la chip du type sur la carte, en tinte — une chip pleine, sans contour, comme
 *   le livre V16 les veut ; l'encre `*-strong` sur sa tinte est mesurée par `contrast.test.ts`.
 * - `zone` : le pointillé qui encadre la zone du point choisi sur la copie, dans la couleur vive.
 */
import { type UIActivityCorrectionPointType } from "../../../ports/primary/ui/types"
import { type BadgeVariant } from "../../atoms/Badge"
import { type IconName } from "../../atoms/icons/Icon"
import { type SemanticColorKey } from "../../theme/tokens/colors"

export type CorrectionPointFace = {
    label: string
    badge: BadgeVariant
    chip: BadgeVariant
    icon: IconName
    zone: SemanticColorKey
}

export const CORRECTION_POINT_FACES: Record<UIActivityCorrectionPointType, CorrectionPointFace> = {
    error: { label: "Erreur", badge: "danger-deep", chip: "danger", icon: "times-circle", zone: "danger" },
    warning: {
        label: "Vigilance",
        badge: "warning-deep",
        chip: "warning",
        icon: "exclamation-triangle",
        zone: "warning",
    },
    success: { label: "Réussite", badge: "success", chip: "success", icon: "check-circle", zone: "success" },
    other: { label: "Point", badge: "neutral", chip: "neutral", icon: "info-circle", zone: "border" },
}
